import React, { useState } from 'react';
import { createForm } from '../../Api/Api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CorporateEnquiryModal = ({ onClose }) => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const res = await createForm(form);
      if (res.success) {
        toast.success("Form submitted successfully!");
        setForm({ name: '', phone: '', email: '', service: '', message: '' });
        setTimeout(() => onClose(), 2000);
      } else {
        toast.error("Submission failed!");
      }
    } catch (err) {
      console.error("Submission failed", err);
      toast.error("Something went wrong.");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4 py-8 sm:py-12">
      <ToastContainer />
      <div className="bg-white rounded-lg p-6 w-full max-w-md sm:max-w-lg shadow-lg">
        <h2 className="text-lg font-semibold mb-4 text-[#0D004C] text-center">
          Corporate Enquiry
        </h2>

        <div className="space-y-3">
          <input
            type="text"
            name="name"
            placeholder="Name"
            className="w-full border px-3 py-2 rounded text-sm"
            value={form.name}
            onChange={handleChange}
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            className="w-full border px-3 py-2 rounded text-sm"
            value={form.phone}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            className="w-full border px-3 py-2 rounded text-sm"
            value={form.email}
            onChange={handleChange}
          />

          <select
            name="service"
            value={form.service}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded text-sm"
          >
            <option value="">Select Service</option>
            <option value="House Keeping">House Keeping</option>
            <option value="Deep Cleaning">Deep Cleaning</option>
            <option value="Painting">Painting</option>
            <option value="Pest Control">Pest Control</option>
          </select>

          <textarea
            name="message"
            placeholder="Your Message"
            className="w-full border px-3 py-2 rounded text-sm"
            rows={3}
            value={form.message}
            onChange={handleChange}
          ></textarea>

          <div className="flex justify-between sm:justify-end gap-2 mt-2">
            <button
              onClick={onClose}
              className="px-4 py-2 border rounded text-gray-600 text-sm w-full sm:w-auto"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-[#0D004C] text-white rounded hover:bg-opacity-80 text-sm w-full sm:w-auto"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateEnquiryModal;
